import React from "react";
import {
  Button, DialogActions, DialogContent, Grid
} from '@mui/material';
import TextInput from "@/common/components/text-input/text-input";
import SwitchInput from "@/common/components/switch-input/switch-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from 'react-intl';
import useCreateEditCountryMaster from "./hooks/useCreateEditCountryMaster";
import PropTypes from "prop-types";
import { apiStatuses } from "@/store/api/constants";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";
import Spinner from "@/common/components/spinner/spinner";

function CreateEditCountryMaster({
  closeModal, activeEditId
}) {

  const {
    values, formik, getEditCountryMasterStatus,
    getEditCountryMasterErrMsg, saveCountryMasterStatus, updateCountryMasterStatus,
  } = useCreateEditCountryMaster(activeEditId);

  const isPending = [saveCountryMasterStatus, updateCountryMasterStatus]
  .includes(apiStatuses.pending);


  const {
     countryName, activeStatus
  } = values;

  return (
    <>
      {
        getEditCountryMasterStatus === apiStatuses.pending && activeEditId
        && <Spinner />
      }

      {getEditCountryMasterStatus === apiStatuses.rejected && activeEditId && (
        <ErrorInPage message={getEditCountryMasterErrMsg} />
      )}

      {(getEditCountryMasterStatus === apiStatuses.succeeded || !activeEditId) &&
        <form onSubmit={formik.handleSubmit}>
          <DialogContent dividers>
            <Grid container spacing={1.25}>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="country-name" size="small" fullWidth
                  value={countryName}
                  inputLabel="country-name"
                  formik={formik}
                  name="countryName"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6}>
                <SwitchInput
                  inputLabel="activeStatus"
                  leftLabel="inactive"
                  rightLabel="active"
                  value={activeStatus}
                  formik={formik}
                  name="activeStatus"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="error" onClick={closeModal} variant="outlined" disabled={isPending}
             sx={{ mr: 1 }}>
              <FormattedMessage id={"cancel"} />
            </Button>
            <AnimateButton>
              <Button type="submit" variant="contained" disabled={isPending} sx={{ mr: 1 }}>
                <FormattedMessage id={"save"} />
              </Button>
            </AnimateButton>
          </DialogActions>
        </form>
      }
    </>
  )
}


CreateEditCountryMaster.propTypes = {
  closeModal: PropTypes.func.isRequired,
  activeEditId: PropTypes.bool,
};

CreateEditCountryMaster.defaultProps = {
  activeEditId: 0,
};



export default CreateEditCountryMaster;